import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 bg-navy" data-id="element-96" data-mp="8mn4mdpzojyr">
      <div className="mx-auto max-w-xl px-3 py-5 sm:px-4 sm:py-8" data-id="element-97" data-mp="df6ti6u4n1iv">
        <SectionHeader dark id="oferta-titulo" eyebrow="Oferta especial — Sistema completo 6 en 1" title="Comienza hoy desde cero y avanza a tu ritmo." data-id="element-98" data-mp="idi3qioc3e1m" />

        <div className="mt-3 rounded-2xl border-[3px] border-dashed border-amarillo bg-white p-3.5 text-center sm:p-5" data-id="element-99" data-mp="re67mkk0jy0s">
          <p className="text-[0.82rem] font-extrabold text-wifi sm:text-base" data-id="element-100" data-mp="wd9e89fn6cav">📡 {PRODUCT_NAME}</p>
          <p className="text-sm font-bold text-navy" data-id="element-101" data-mp="2t62uurfjmwbe">6 Tomos + 5 Bonos</p>
          <p className="mt-0.5 text-sm font-medium text-negro" data-id="element-102" data-mp="2y44af2drgdi4">🎁 Bonos valorados en {BONUS_TOTAL}</p>

          <p className="mx-auto mt-2 inline-block rounded-md bg-red-600 px-3 py-1 text-xs font-extrabold uppercase text-white" data-id="element-103" data-mp="12n8mfvina0mq">
            🔥 Oferta especial
          </p>
          <p className="mt-1 font-display text-5xl uppercase leading-none text-navy sm:text-6xl" data-id="element-104" data-mp="xuyygl13ban3">
            Hoy: <span className="bg-amarillo px-1.5" data-id="element-105" data-mp="svck289izocp">{PRICE}</span>
          </p>
          <p className="mt-1.5 text-xs font-medium text-negro/70 sm:text-sm" data-id="element-106" data-mp="oxyfitwsi4r1">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <CtaButton href={CHECKOUT_URL} className="mt-2.5" data-id="element-107" data-mp="1gmru6n7jn9yi">
            🚀 Sí, quiero el sistema completo por {PRICE}
          </CtaButton>
          <p className="mt-1 text-xs font-medium text-negro/70" data-id="element-108" data-mp="1ck4ygb7r54w1">Acceso Inmediato • Garantía de 7 Días</p>
        </div>
      </div>
    </section>;
}